module.exports = __webpack_public_path__ + "static/img/xml.a03b766e.png";